import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'
import {
  BookingMultiDayForm,
  CategoryMapping,
  DateGroupFormValue,
  ProductGroupsOptions,
  ProductGroupsPurchaseFlow,
  TargetGroup
} from '../../../shared/models'
import { enumerateDaysBetweenDates } from '../../../shared/utils/dates'
import { AppState } from '../../../core/core.state'
import { Store } from '@ngrx/store'
import { combineLatest, Observable, of, Subject } from 'rxjs'
import {
  catchError,
  filter,
  map,
  take,
  tap,
  timeout,
  distinctUntilChanged
} from 'rxjs/operators'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { ConfigurationService } from '../../../shared/services/configuration.service'
import { PurchaseParams, SaleItem } from '../../sale/sale-item/sale-item'
import { ConfigOptionsKeys } from '../../../shared/constants'
import { configOptionsSelector } from '../../configuration-option/configuration-option.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { Router } from '@angular/router'
import { productSelectors } from '../../product/product.selectors'
import { Dictionary } from '@ngrx/entity'
import { Product } from '../../product/product'
import { productActions } from '../../product/product.actions'

import { bookingActions } from '../../booking/booking.actions'
import { bookingSelectors } from '../../booking/booking.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { delay } from 'rxjs/operators'
import { BookingMultiDayService } from './booking-multi-day.service'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { ParticipationService } from '../../booking/participation/participation.service'

type tabs = 'datesGroups' | 'rooms' | 'facilities' | 'catering' | 'completed'
type MultiDaySaleItemDraft = Partial<SaleItem> & {
  productId: number
  quantity: number
  customerCategory: number
  params: PurchaseParams
}

@UntilDestroy()
@Component({
  selector: 'booking-multi-day',
  templateUrl: './booking-multi-day.component.html',
  styleUrls: ['./booking-multi-day.component.scss']
})
export class BookingMultiDayComponent implements OnInit {
  @Output() onSubmit: EventEmitter<MultiDaySaleItemDraft[]> = new EventEmitter()
  @Input() loading: boolean = false
  public activeTab: tabs = 'datesGroups'
  public isLoadingProducts: boolean = true
  public tabs: tabs[] = ['datesGroups', 'rooms', 'facilities', 'catering']

  public booking: BookingMultiDayForm = {
    // details: {
    // targetGroup: 'adults',
    // isSleepOver: false,
    // is75SleepOver: true,
    // dates: [
    //   new Date('2022-06-24T14:05:58.000Z'),
    //   new Date('2022-06-28T14:05:58.000Z')
    // ],
    // participants: {
    //   numberRoomsRequired: 3,
    //   numberSleepOver: 10,
    //   numberDaytime: 2
    // }
    // }
  }
  public isLoadingProducts$ = this.store.select(
    productSelectors.selectIsLoading
  )
  public roomDateList: Moment[] = []
  public facilityDateList: Moment[] = []
  public cateringDateList: Moment[] = []
  private doReFetch: boolean = true
  //
  public roomsProducts$: Observable<Product[]> = of([])
  public cateringProducts$: Observable<Product[]> = of([])
  public facilitiesProducts$: Observable<Product[]> = of([])
  //
  public subjectRoomsProducts$: Subject<Product[]> = new Subject<Product[]>()
  public subjectCteringProducts$: Subject<Product[]> = new Subject<Product[]>()
  public subjectFacilitiesProducts$: Subject<Product[]> = new Subject<
    Product[]
  >()

  public bookingIsLoading$ = this.store.select(bookingSelectors.selectIsLoading)
  public saleItems: MultiDaySaleItemDraft[]

  public productGroupsPurchaseFlow: Partial<ProductGroupsPurchaseFlow>
  public productGroupsOptions$ = configOptionsSelector(
    this.store,
    ConfigOptionsKeys.PRODUCT_GROUPS_PURCHASE_FLOW_CARD
  )

  constructor(
    private store: Store<AppState>,
    public configurationService: ConfigurationService,
    public bookingMultiDayService: BookingMultiDayService,
    public router: Router,
    private participationService: ParticipationService
  ) {}

  ngOnInit() {
    this.productGroupsOptions$.pipe(take(1)).subscribe((option: string) => {
      if (!option) {
        console.warn('Web option PRODUCT_GROUPS_PURCHASE_FLOW_CARD missing')
        return null
      }
      this.productGroupsPurchaseFlow = JSON.parse(
        option
      ) as ProductGroupsPurchaseFlow

      console.log(
        'productGroupsPurchaseFlow config options',
        this.productGroupsPurchaseFlow
      )

      this.fetchProducts()
      this.doReFetch = false
      const { rooms, facilities, catering } = this.productGroupsPurchaseFlow

      // this.roomsProducts$ = this.selectProducts$(rooms.productIds)
      // this.facilitiesProducts$ = this.selectProducts$(facilities.productIds)
      // this.cateringProducts$ = this.selectProducts$(catering.productIds)
      // combine above observables
      combineLatest([
        this.selectProducts$(rooms.productIds),
        this.selectProducts$(facilities.productIds),
        this.selectProducts$(catering.productIds)
      ])
        .pipe(take(1))
        .subscribe(([rooms, catering, facilities]) => {
          // this.roomsProducts$ = of(rooms)
          // this.cateringProducts$ = of(catering)
          // this.facilitiesProducts$ = of(facilities)
          console.log(
            'ngOnInit productGroupsOptions$',
            'selected products for the steps',
            {
              rooms,
              catering,
              facilities
            }
          )
        })
    })
  }
  private fetchProducts() {
    let productsIds = []
    Object.values(this.productGroupsPurchaseFlow).map((pr: any) => {
      if (pr.productIds) {
        productsIds = [...productsIds, ...pr.productIds]
      }
    })
    productsIds = [...new Set(productsIds)]
    const params = RequestQueryBuilder.create({
      join: [
        { field: 'documents' },
        { field: 'tags' },
        { field: 'translations' },
        { field: 'dependantProducts' },
        { field: 'parentBookableProducts' },
        { field: 'parentBookableProducts.tags' },
        { field: 'parentBookableProducts.translations' },
        { field: 'parentBookableProducts.dependantProducts' }
      ],
      search: {
        id: {
          [CondOperator.IN]: productsIds
        }
      }
    })
    if (productsIds.length > 0) {
      this.bookingMultiDayService
        .getManyProducts(params)
        .pipe(take(1))
        .subscribe((pr) => {
          this.store.dispatch(
            normalizationActions.upsertMany({
              entities: normalizeToSchema({ products: pr })
            })
          )
          this.isLoadingProducts = false
        })
    } else {
      this.isLoadingProducts = false
    }
  }
  public productGroupSubmit(value: any, tab: tabs) {
    switch (tab) {
      case 'rooms':
        this.booking.rooms = value
        break
      case 'facilities':
        this.booking.facilities = value
        break
      case 'catering':
        this.booking.catering = value
    }
    this.nextTab()
  }

  public datesGroupsSubmit(dateGroupForm: DateGroupFormValue) {
    this.booking.details = dateGroupForm

    const startDate = moment(dateGroupForm.startDate)
    const endDate = moment(dateGroupForm.endDate)

    const diffDays = endDate.diff(startDate, 'days')

    this.store.dispatch(
      bookingActions.fetchMany({
        params: RequestQueryBuilder.create({
          join: [{ field: 'participations' }],

          search: {
            startDate: {
              [CondOperator.BETWEEN]: [
                startDate.startOf('day').toISOString(),
                endDate.endOf('day').toISOString()
              ]
            }
          }
        })
      })
    )

    this.roomDateList = enumerateDaysBetweenDates(startDate, endDate, false)

    this.facilityDateList = enumerateDaysBetweenDates(startDate, endDate)

    this.cateringDateList = enumerateDaysBetweenDates(startDate, endDate)

    const isExternal = !(
      dateGroupForm.isSleepOver && dateGroupForm.is75SleepOver
    )

    this.updateProductGroupsByCategory({
      targetGroup: dateGroupForm.targetGroup,
      isMultiDay: diffDays > 1,
      isExternal
    })

    if (this.isRoomStepDisabled(dateGroupForm)) {
      this.nextTab('facilities')
      return
    }

    this.nextTab()
  }

  public nextTab(tab?: tabs) {
    if (tab) {
      this.activeTab = tab
      return
    }
    switch (this.activeTab) {
      case 'datesGroups':
        this.activeTab = 'rooms'
        break
      case 'rooms':
        this.activeTab = 'facilities'
        break
      case 'facilities':
        this.activeTab = 'catering'
        break
      case 'catering':
        this.onFinish()
        break
    }
  }

  public onFinish() {
    this.store
      .select(productSelectors.selectEntities)
      .pipe(take(1))
      .subscribe((productEntities) => {
        this.onSubmit.emit(
          this.convertBookingToSaleItem(this.booking, productEntities)
        )
      })
  }

  private getRoomBoundaryMoment(
    currentDate: Moment,
    explicitTime: Date,
    productDefaultTime: string
  ): Moment {
    const normalizedProductDefaultTime = moment(
      `2020-01-01 ${productDefaultTime}`,
      ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss']
    )

    if (normalizedProductDefaultTime.isValid()) {
      return moment(currentDate).set({
        hour: normalizedProductDefaultTime.get('hour'),
        minute: normalizedProductDefaultTime.get('minute')
      })
    }

    const fallbackTime = moment(explicitTime)

    return moment(currentDate).set({
      hour: fallbackTime.get('hour'),
      minute: fallbackTime.get('minute')
    })
  }

  private getNormalizedExplicitRoomTime(
    rawTime: Date
  ): Date {
    return moment(
      `2020-01-01 ${moment(rawTime).format('HH:mm')}`,
      'YYYY-MM-DD HH:mm'
    ).toDate()
  }

  private getNormalizedProductDefaultTime(
    rawTime: string,
    fallbackTime: string
  ): string {
    const parsedTime = moment(`2020-01-01 ${rawTime}`, [
      'YYYY-MM-DD HH:mm',
      'YYYY-MM-DD HH:mm:ss'
    ])

    return parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : fallbackTime
  }

  public isTabDisabled(id: tabs) {
    switch (id) {
      case 'datesGroups':
        return false
      case 'rooms':
        return this.isRoomStepDisabled(this.booking.details)

      default:
        return !this.booking.details
    }
  }

  public moveToStep(tab: tabs) {
    // set the active tab to the one clicked only if index is less than current active tab index
    if (this.tabs.indexOf(this.activeTab) > this.tabs.indexOf(tab)) {
      this.activeTab = tab
    }
  }

  private convertBookingToSaleItem(
    bookingDetails: BookingMultiDayForm,
    productEntities: Dictionary<Product>
  ): MultiDaySaleItemDraft[] {
    if (!bookingDetails) {
      return []
    }

    const salesItems: MultiDaySaleItemDraft[] = []

    const { rooms, facilities, catering, details } = bookingDetails

    // rooms selection
    if (rooms?.dates && rooms.dates.length > 0) {
      const sortedDates = rooms?.dates.sort((a, b) =>
        a.date > b.date ? 1 : -1
      )

      sortedDates?.forEach((currentDate, dateIndex) => {
        const nextDate =
          dateIndex + 1 < sortedDates.length
            ? sortedDates[dateIndex + 1].date
            : sortedDates[dateIndex].date
        const products = currentDate.products.filter(
          (p) => Number(p?.qty) > 0 && Number(p?.persons) > 0
        )

        products.map((p) => {
          const activityProduct = productEntities[p.productId]
          const normalizedCheckIn = this.getNormalizedExplicitRoomTime(
            rooms.checkIn
          )
          const normalizedCheckOut = this.getNormalizedExplicitRoomTime(
            rooms.checkOut
          )
          const rawDefaultStartTime =
            typeof activityProduct?.defaultStartTime === 'string'
              ? activityProduct.defaultStartTime
              : moment(activityProduct?.defaultStartTime).format('HH:mm:ss')
          const rawDefaultEndTime =
            typeof activityProduct?.defaultEndTime === 'string'
              ? activityProduct.defaultEndTime
              : moment(activityProduct?.defaultEndTime).format('HH:mm:ss')
          const normalizedDefaultStartTime =
            this.getNormalizedProductDefaultTime(
              rawDefaultStartTime,
              '00:00:00'
            )
          const normalizedDefaultEndTime = this.getNormalizedProductDefaultTime(
            rawDefaultEndTime,
            '23:59:00'
          )
          const participantLimits =
            this.participationService.calculateParticipantLimits(
              activityProduct,
              null,
              null
            )
          const maxGuestCount = participantLimits.maxGuestInvites
          let pendingGuestCount = p.persons

          for (let index = 0; index < p.qty; index++) {
            const targetParticipantCount =
              pendingGuestCount < maxGuestCount
                ? pendingGuestCount
                : maxGuestCount

            pendingGuestCount = pendingGuestCount - targetParticipantCount

            const startDate = this.getRoomBoundaryMoment(
              moment(currentDate.date),
              normalizedCheckIn,
              normalizedDefaultStartTime
            )

            const endDate =
              moment(nextDate).diff(moment(currentDate.date), 'days') > 1 ||
              moment(nextDate).diff(moment(currentDate.date), 'days') == 0
                ? this.getRoomBoundaryMoment(
                    moment(currentDate.date).clone().add(1, 'day'),
                    normalizedCheckOut,
                    normalizedDefaultEndTime
                  ).subtract(1, 'minutes')
                : startDate.clone().add(1, 'day').subtract(1, 'minutes')

            salesItems.push({
              productId: p.productId, // activity id
              quantity: 1,
              note: p.note,
              tags: [...productEntities[p.productId]?.tags],
              customerCategory: CategoryMapping[details.targetGroup],
              params: {
                startDate,
                endDate,
                bookableProductId: p.bookableProductId, // resource id
                bookableLinkedProductId: p.productId, // activity id
                invitedGuests: Array.from(
                  Array(targetParticipantCount).keys()
                ).map((i) => ({}))
              }
            })
          }
        })
      })
    }
    facilities?.dates?.forEach((currentDate) => {
      const products = currentDate.products.filter(
        (p) => Number(p?.qty) > 0 && p.selected === true
      )
      const fDate = JSON.parse(JSON.stringify(currentDate))

      salesItems.push(
        ...products.map((p): MultiDaySaleItemDraft => {
          const startTime = moment(p.checkIn)
          const endTime = moment(p.checkOut)
          return {
            productId: p.productId,
            quantity: 1,
            note: p.note,
            tags: p.option
              ? [p.option]
              : [...productEntities[p.productId]?.tags],
            customerCategory: CategoryMapping[details.targetGroup],

            params: {
              startDate: moment(fDate.date).set({
                hour: startTime.get('hours'),
                minute: startTime.get('minutes')
              }),
              endDate: moment(fDate.date).set({
                hour: endTime.get('hours'),
                minute: endTime.get('minutes')
              }),
              bookableProductId: p.bookableProductId,
              bookableLinkedProductId: p.productId,
              invitedGuests: Array.from(Array(p.qty).keys()).map((i) => ({}))
            }
          }
        })
      )
    })

    catering?.dates?.forEach((currentDate) => {
      const products = currentDate.products.filter(
        (p) => Number(p?.qty) > 0 && p.selected === true
      )
      salesItems.push(
        ...products.map((p): MultiDaySaleItemDraft => {
          const slotMinutes = productEntities[p.productId].slotMinutes
          const startTime = moment(p.time)
          const endTime = moment(p.time)
            .add(slotMinutes, 'minutes')
            .subtract(1, 'minute')
          const fDate = JSON.parse(JSON.stringify(currentDate))

          const qty = Number(p.qty)
          return {
            productId: p.productId,
            quantity: qty,
            customerCategory: CategoryMapping[details.targetGroup],
            tags: [...productEntities[p.productId]?.tags],
            params: {
              startDate: moment(fDate.date).set({
                hour: startTime.get('hours'),
                minute: startTime.get('minutes')
              }),
              endDate: moment(fDate.date).set({
                hour: endTime.get('hours'),
                minute: endTime.get('minutes')
              }),
              bookableProductId: p.bookableProductId ?? null
            }
          }
        })
      )
    })

    return salesItems.map((s) => ({ ...s, description: details.targetGroup }))
  }

  private updateProductGroupsByCategory({
    targetGroup,
    isExternal,
    isMultiDay
  }: {
    targetGroup: TargetGroup
    isMultiDay: boolean
    isExternal: boolean
  }) {
    if (!targetGroup) {
      return
    }
    if (this.doReFetch) {
      this.fetchProducts()
    }

    const { rooms, facilities, catering } = this.productGroupsPurchaseFlow
    const roomsIds =
      rooms.categoriesProductIds?.[targetGroup]?.length > 0
        ? rooms.categoriesProductIds[targetGroup]
        : rooms.productIds

    const cateringIds =
      catering.categoriesProductIds?.[targetGroup]?.length > 0
        ? catering.categoriesProductIds[targetGroup]
        : catering.productIds

    let facilitiesIds =
      facilities.categoriesProductIds?.[targetGroup]?.length > 0
        ? facilities.categoriesProductIds[targetGroup]
        : facilities.productIds

    if (isMultiDay && isExternal) {
      facilitiesIds = facilities.categoriesProductIds.externalMultiDay
    }
    if (isMultiDay && !isExternal) {
      facilitiesIds = facilities.categoriesProductIds.internalMultiDay
    }
    if (!isMultiDay && isExternal) {
      facilitiesIds = facilities.categoriesProductIds.externalSingleDay
    }
    if (!isMultiDay && !isExternal) {
      facilitiesIds = facilities.categoriesProductIds.internalSingleDay
    }

    this.roomsProducts$ = this.selectProducts$(roomsIds)
    this.cateringProducts$ = this.selectProducts$(cateringIds)
    this.facilitiesProducts$ = this.selectProducts$(facilitiesIds)
    // combine above observables
    combineLatest([
      this.roomsProducts$,
      this.cateringProducts$,
      this.facilitiesProducts$
    ])
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b))
      )
      .subscribe(([rooms, catering, facilities]) => {
        this.doReFetch = false
        this.roomsProducts$ = of(rooms)
        this.cateringProducts$ = of(catering)
        this.facilitiesProducts$ = of(facilities)
        console.log(
          'updateProductGroupsByCategory',
          'selected products for the steps',
          {
            rooms,
            catering,
            facilities
          }
        )
      })
  }

  private selectProducts$(productsIds: number[]) {
    return this.store.select(productSelectors.selectAll).pipe(
      map(
        (products) => products.filter((g) => productsIds.includes(g.id))
        // .filter((g) => g.parentBookableProducts?.length > 0)
      )
    )
  }

  private isRoomStepDisabled(details: DateGroupFormValue) {
    return (
      !details ||
      details?.participants.numberSleepOver < 1 ||
      !Boolean(details.isSleepOver) ||
      moment(details.startDate).isSame(moment(details.endDate), 'day')
    )
  }

  private getStepCategoryProductIds(step: ProductGroupsOptions): number[] {
    return (
      Object.values(step.categoriesProductIds)
        // .filter(Boolean)
        .reduce((acc, curr) => {
          return [...acc, ...curr]
        }, [])
    )
  }
}
